import React from 'react';
import { Link } from 'react-router-dom';
import { ApertureMark } from './Logo';
import '../styles/footer.css';

const SiteFooter = () => (
  <footer className="footer">
    <div className="shell">
      <p className="footer-wordmark" data-reveal="mask">
        Kévin <em>Gelineau</em>
      </p>

      <div className="footer-grid">
        <div className="footer-col">
          <span className="footer-heading">Contact</span>
          <a className="footer-link" href="mailto:kevin.gelineau90@gmail.com">
            kevin.gelineau90@gmail.com
          </a>
          <a className="footer-link" href="tel:+33650923084">
            06 50 92 30 84
          </a>
        </div>

        <div className="footer-col">
          <span className="footer-heading">Réseaux</span>
          <a
            className="footer-link"
            href="https://www.linkedin.com/in/kevin-gelineau/"
            target="_blank"
            rel="noopener noreferrer"
          >
            LinkedIn
          </a>
        </div>

        <div className="footer-col">
          <span className="footer-heading">Localisation</span>
          <span className="footer-link">Angers, Pays de la Loire</span>
          <span className="footer-link">Freelance &amp; agence</span>
        </div>
      </div>

      <div className="footer-bottom">
        <span className="footer-sign">
          <ApertureMark size={20} className="footer-mark" />© {new Date().getFullYear()} Kévin
          Gelineau
        </span>
        <nav className="footer-legal" aria-label="Liens légaux">
          <Link to="/mentions-legales">Mentions légales</Link>
          <Link to="/politique-de-confidentialite">Confidentialité</Link>
          <Link to="/politique-cookies">Cookies</Link>
          <Link to="/cgu">CGU</Link>
        </nav>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
